import React from 'react';
import CodeGenarator from './../CodeComponent/codeGenerator';
import CopyClip from './copyClip';

export default class Main5Component extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        let stringCode4 = `
$(document).ready(function() {
  LessCode.drawer({
     ...
   })
});`
        return(
            <div className="main bg-light" data-nav="5">
            <h3 id="options-options">Options</h3>
            <p>The following table lists all the options that can be used in the drawer function.</p>
            <div className="table-responsive-lg">
                <table className="table table-bordered table-dark">
                    <thead>
                        <tr>
                            <th scope="col">name</th>
                            <th scope="col">type</th>
                            <th scope="col">default</th>
                            <th scope="col">description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>class</td>
                            <td>object</td>
                            <td></td>
                            <td>custom class name</td>
                        </tr>
                        <tr>
                            <td>parentElementItems</td>
                            <td>string(elements)<span className="text-info"> or </span>jQuery elements</td>
                            <td></td>
                            <td>new parent element</td>
                        </tr>
                        <tr>
                            <td>withNavbarFormsBootstrap</td>
                            <td>boolean</td>
                            <td>false</td>
                            <td>Add navbar form to drawer?</td>
                        </tr>
                        <tr>
                            <td>withNavItemBootstrap</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>Add navbar nav-item to drawer?</td>
                        </tr>
                        <tr>
                            <td>withNavbarBrandBootstrap</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>Add navbar navbar-brand to drawer?</td>
                        </tr>
                        <tr>
                            <td>withDropDownBotstrap</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>Add navbar drop-down to drawer?</td>
                        </tr>
                        <tr>
                            <td>changeBrandSearchBotstrap</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>change navbar-brand with input search when navbar in collapse mode?</td>
                        </tr>
                        <tr>
                            <td>exitResizeing</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>close drawer when navbar exit from collapse mode?<br/>
                                <span className="text-danger">(if use resizing event in your project should use
                                    function <span className="text-info">LessCode.resizeDrawers()</span> in your
                                    resizing function.)</span></td>
                        </tr>
                        <tr>
                            <td>customHeadDrawer</td>
                            <td>string(elements)<span className="text-info"> or </span>jQuery elements</td>
                            <td></td>
                            <td>add your custom head to header drawer</td>
                        </tr>
                        <tr>
                            <td>headerStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized header style.</td>
                        </tr>
                        <tr>
                            <td>drawerInsideStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized drawer style.</td>
                        </tr>
                        <tr>
                            <td>drawerItemStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized drawer items style.</td>
                        </tr>
                        <tr>
                            <td>drawerItemHoverEnterStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized drawer items enter style.</td>
                        </tr>
                        <tr>
                            <td>drawerItemHoverExitStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized drawer items exit style.</td>
                        </tr>

                        <tr>
                            <td>textStyle</td>
                            <td>css object</td>
                            <td></td>
                            <td>customized drawer texts style.</td>
                        </tr>
                        <tr>
                            <td>addQuery</td>
                            <td>function</td>
                            <td></td>
                            <td>add your queary to drawer.</td>
                        </tr>

                        <tr>
                            <td>showInsideCloseButton</td>
                            <td>boolean</td>
                            <td>true</td>
                            <td>show close button in drawer?</td>
                        </tr>
                        <tr>
                            <td>showOutsideCloseButton</td>
                            <td>boolean</td>
                            <td>false</td>
                            <td>show close button outside drawer?</td>
                        </tr>
                        <tr>
                            <td>insideCloseButton</td>
                            <td>string(elements)<span className="text-info"> or </span>jQuery elements</td>
                            <td></td>
                            <td>customized inside close button.</td>
                        </tr>

                        <tr>
                            <td>outsideCloseButton</td>
                            <td>string(elements)<span className="text-info"> or </span>jQuery elements</td>
                            <td></td>
                            <td>customized outside close button.</td>
                        </tr>
                        <tr>
                            <td>customJqueryElement</td>
                            <td>string(elements)<span className="text-info"> or </span>jQuery elements</td>
                            <td></td>
                            <td>add your custom element to drawer.</td>
                        </tr>
                        <tr>
                            <td>customJqueryElementFirst</td>
                            <td>boolean</td>
                            <td>false</td>
                            <td>add custom elements to first element drawer?</td>
                        </tr>
                        <tr>
                            <td>enterAnimation</td>
                            <td>function</td>
                            <td></td>
                            <td>customized enter animation function.</td>
                        </tr>
                        <tr>
                            <td>exitAnimation</td>
                            <td>function</td>
                            <td></td>
                            <td>customized exit animation function.</td>
                        </tr>
                        <tr>
                            <td>defualtStylesPosition</td>
                            <td>number</td>
                            <td>0</td>
                            <td>use default theme.</td>
                        </tr>

                    </tbody>
                </table>
            </div><br/><br/>
            <h3 id="class-objects">class object</h3>
            <ul>
                <li>drawer: class name main drawer.</li>
                <li>drawerInside: class name inside drawer.</li>
                <li>drawerOutside: class name outside drawer.</li>
                <li>brandKeeper: class name hedear drawer.</li>
                <li>showButton: class name button show drawer.("add name custom show drawer button")</li>
            </ul>
            <h3 id="usage-options">usage</h3>
            <p>Define your choice instead of ...</p>
            <div className="container">
                <div className="row ">
                    <div className="col-12 col-code-keeper position-relative">
                        <div className="clipbord-keeper1">
                            {/* <svg className="clipbord-svg" data-codes="4" id="i-clipboard"
                            title="" data-original-title="Copy to clipboard"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                strokeWidth="2">
                                <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                            </svg>
                            <textarea className="clipbordArea" data-codes="4" cols="auto" rows="auto"></textarea> */}
                            <CopyClip value={stringCode4}></CopyClip>
                        </div>
                        <div className="code-keeper">
                        <CodeGenarator code={stringCode4}></CodeGenarator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
    

}